import { render, staticRenderFns } from "./v-footer-social-icon.vue?vue&type=template&id=1d476100&"
import script from "./v-footer-social-icon.vue?vue&type=script&lang=js&"
export * from "./v-footer-social-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports